import { render, staticRenderFns } from "./proposal-24-mc-leads.vue?vue&type=template&id=691daad8"
import script from "./proposal-24-mc-leads.vue?vue&type=script&lang=js"
export * from "./proposal-24-mc-leads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports